/** Paleta pastel para avatares de iniciais no inbox (fundo + texto). */
const INBOX_AVATAR_PALETTE: Array<{ bg: string; color: string }> = [
  { bg: '#E8F2F0', color: '#2F5F56' },
  { bg: '#F5EDE3', color: '#7A5C2E' },
  { bg: '#E3EDF5', color: '#2E5578' },
  { bg: '#EDE8F4', color: '#534878' },
  { bg: '#F5E8EA', color: '#7A4550' },
  { bg: '#E8F0E6', color: '#3F5C3A' },
  { bg: '#F0EBE6', color: '#6B5344' },
  { bg: '#E6EAF5', color: '#3F4A82' },
];

function hashName(name: string): number {
  return name.split('').reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
}

export function getInboxAvatarColors(name: string): { bg: string; color: string } {
  const key = (name || '?').trim() || '?';
  const idx = Math.abs(hashName(key)) % INBOX_AVATAR_PALETTE.length;
  return INBOX_AVATAR_PALETTE[idx];
}

export function getInboxInitials(name?: string): string {
  if (!name?.trim()) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
